angular
  .module('resyApp')
  .directive('resyAutofillSync', resyAutofillSync);

function resyAutofillSync() {
  return {

    link(scope, elem, attrs) {
      /*
       * Fix autofill issues where Angular doesn't know about autofilled inputs
       * https://github.com/angular/angular.js/issues/1460#issuecomment-53459701
       * - MY
       */
      if (attrs.ngSubmit) {
        elem.unbind('submit').bind('submit', (e) => {
          e.preventDefault();

          const arr = elem.find('input');

          if (arr.length > 0) {
            arr.triggerHandler('input');
            arr.triggerHandler('change');
            arr.triggerHandler('keydown');
            scope.$apply(attrs.ngSubmit);
          }
        });
      }
    },
  };
}

export default () => {};
